import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Shared";
import { IMAGES } from "../config/siteConfig";
import { viewportOnce } from "../lib/motion";

const INDICATORS = ["Strategic Talent Solutions", "Industry-Focused Recruitment", "Responsive Client Support"];

export const TrustIntro = () => (
  <section id="about" className="bg-[#F7F7F5] py-24 md:py-36" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
      <div>
        <SectionLabel>Who We Are</SectionLabel>
        <Reveal>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#111111]">
            People Power <span className="text-[#C62828]">Progress.</span>
          </h2>
        </Reveal>
        <Reveal i={1}>
          <p className="font-body text-[#555] text-lg leading-relaxed mt-8 max-w-xl">
            At Prospera Staffing, we believe the right people can transform businesses. We help organizations
            discover, attract, and retain talent that creates measurable impact — building teams that endure.
          </p>
        </Reveal>

        <div className="mt-10 space-y-4">
          {INDICATORS.map((t, i) => (
            <Reveal key={t} i={i + 2}>
              <div className="flex items-center gap-4">
                <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#C62828]/10 flex items-center justify-center">
                  <Check size={15} className="text-[#C62828]" />
                </span>
                <span className="font-body font-500 text-[#1F1F1F]">{t}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal i={5}>
          <Link
            to="/services"
            data-testid="about-cta"
            className="group inline-flex items-center gap-2 mt-12 font-accent uppercase tracking-widest text-sm text-[#111111] hover:text-[#C62828] transition-colors"
          >
            Discover Our Solutions
            <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={viewportOnce}
        transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        className="relative"
      >
        <div className="absolute -top-5 -left-5 w-full h-full border border-[#C62828] rounded-sm hidden md:block" />
        <div className="relative overflow-hidden rounded-sm">
          <img
            src={IMAGES.trust}
            alt="Diverse team of corporate professionals collaborating in a modern Dubai office"
            className="w-full h-[420px] md:h-[560px] object-cover"
          />
        </div>
      </motion.div>
    </div>
  </section>
);

export default TrustIntro;
